import TermsAndConditionsComponent from './TermsAndConditionsComponent'

export default TermsAndConditionsComponent
